// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"276": "367d816131fdffab","39": "14657279d864b19b",}[chunkId] + ".css"
}